export enum SelectionType {
  AddToList = 'AddToList',
  CompareProducts = 'CompareProducts',
  AddToInventory = 'AddToInventory',
}
